import { createIcon } from '@chakra-ui/icons'

export const ZoomPlusIcon = createIcon({
  displayName: 'ZoomPlusIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      d="M18.0001 13C18.5524 13 19.0001 12.5523 19.0001 12C19.0001 11.4477 18.5524 11 18.0001 11L13.0001 11L13.0003 5.99999C13.0003 5.44771 12.5527 4.99997 12.0004 4.99995C11.4481 4.99993 11.0003 5.44763 11.0003 5.99991L11.0001 11H5.85779C5.3055 11 4.85779 11.4477 4.85779 12C4.85779 12.5523 5.3055 13 5.85779 13H11L10.9998 18C10.9998 18.5522 11.4475 19 11.9998 19C12.5521 19 12.9998 18.5523 12.9998 18L13 13H18.0001Z"
      fill="#231B22"
    />
  ),
})
